import React from "react";
import PropTypes from "prop-types";
import JsxParser from "react-jsx-parser";
import { Link } from "react-router-dom";
import WarningSmallIcon from "assets/svgs/warningSmallIcon.svg";
import InfoSmallIcon from "assets/svgs/infoSmallIcon.svg";
import ErrorSmallIcon from "assets/svgs/errorSmallIcon.svg";
import SuccessSmallIcon from "assets/svgs/checkedCircleBold.svg";

import "./AlertNotice.scss";

const AlertNotice = ({
  message,
  type = "information",
  noBorder = false,
  withLink = false,
  link,
  onClick = () => {},
  inline,
}) => {
  const alertTypes = {
    information: {
      class: "alert-info",
      icon: InfoSmallIcon,
    },
    warning: {
      class: "alert-warning",
      icon: WarningSmallIcon,
    },
    success: {
      class: "alert-success",
      icon: SuccessSmallIcon,
    },
    error: {
      class: "alert-error",
      icon: ErrorSmallIcon,
    },
  };

  let alertType = type;
  if (!alertTypes[alertType]) {
    alertType = "information";
  }

  const inlineClass = inline ? "inline-flex" : "";
  const noBorderClass = noBorder ? "alert-no-border" : "";

  let CurrentIcon = alertTypes[alertType].icon;

  const handleClick = (e) => {
    if (e.target.nodeName === "BUTTON") {
      onClick();
    }
  };

  return (
    <div className={`alert-container ${noBorderClass}`}>
      {!noBorder && (
        <div className={`alert-border ${alertTypes[alertType].class}`}></div>
      )}
      <div
        className={`alert ${alertTypes[alertType].class} d-flex ${inlineClass} ${noBorderClass}`}
      >
        {/*<i className={`fa ${alertTypes[alertType].icon} pr-2`} />*/}
        <div className="alert-content">
          <CurrentIcon />
          {withLink ? (
            <JsxParser
              bindings={{
                link,
              }}
              components={{ Link }}
              jsx={`<p className="m-0">${message}</p>`}
            />
          ) : (
            <p
              className="m-0"
              onClick={handleClick}
              dangerouslySetInnerHTML={{ __html: message }}
            />
          )}
        </div>
      </div>
    </div>
  );
};

AlertNotice.propTypes = {
  message: PropTypes.string.isRequired,
  type: PropTypes.string,
  noBorder: PropTypes.bool,
  withLink: PropTypes.bool,
  link: PropTypes.string,
  onClick: PropTypes.func,
  inline: PropTypes.bool,
};

export default AlertNotice;
